module.exports = __webpack_public_path__ + "assets/img/cf_2.29c5d44f.png";